import { gql } from '@ori/fetching';

export const inviteFriendQuery = gql`
  query inviteFriend($consultant: Int!) {
    inviteFriendProfile(consultantNumber: $consultant) {
      firstName
      lastName
      photoUrl
    }
  }
`;
